const COP_TO_USD_FACTOR = 4 / 1000;

const isPriceString = (text) => {
  if (text === "check" || text === "dash" || typeof text !== "string") return false;
  if (/personalizada|custom pricing/i.test(text)) return false;
  return /\$|COP/i.test(text) || /^(desde|from)\s/i.test(text.trim());
};

const parseCopAmount = (text) => {
  const match = text.match(/\$\s*([\d.,]+)|(?:COP\s*)?\$?\s*([\d.,]+)/i);
  const raw = match?.[1] ?? match?.[2];
  if (!raw) return null;

  if (raw.includes(".") && raw.includes(",")) {
    return null;
  }

  let normalized = raw;
  if (raw.includes(".") && !raw.includes(",")) {
    const parts = raw.split(".");
    if (parts.length > 2 || (parts.length === 2 && parts[1].length === 3)) {
      normalized = raw.replace(/\./g, "");
    }
  } else if (raw.includes(",")) {
    normalized = raw.replace(/,/g, "");
  }

  const amount = Number(normalized);
  return Number.isFinite(amount) ? amount : null;
};

const formatUsd = (amount) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);

export const convertCopToUsd = (copAmount) => copAmount * COP_TO_USD_FACTOR;

export const convertPriceStringToUsd = (text) => {
  if (!isPriceString(text)) return text;

  const copAmount = parseCopAmount(text);
  if (copAmount === null) return text;

  const usd = formatUsd(convertCopToUsd(copAmount));
  if (/^(desde|from)\s/i.test(text.trim())) {
    return `From ${usd}`;
  }
  return usd;
};

export const formatPlanPrice = (precio, lang) => {
  if (lang !== "en") return `COP ${precio}`;
  return convertPriceStringToUsd(precio);
};
